const content = document.getElementById('quick-add-modal-content');

if (content) {
  const addSummary = () => {
    if (content.querySelector('.sc-quick-add-summary')) return;
    const titleLink = content.querySelector('.view-product-title a, .product-header > a');
    const picker = content.querySelector('variant-picker');
    if (!titleLink || !picker) return;
    const path = new URL(titleLink.href, location.origin).pathname;
    const card = [...document.querySelectorAll('.sc-product-card[data-product-url]')].find(
      (item) => new URL(item.dataset.productUrl, location.origin).pathname === path
    );
    const template = card?.querySelector('template[data-sc-quick-add-summary]');
    if (template) picker.before(template.content.cloneNode(true));
  };
  new MutationObserver(addSummary).observe(content, {childList: true, subtree: true});
  addSummary();
}
